module.exports = {"welcome":"Your welcome\n bonus awaits you","welcome_mobile":"Your welcome bonus","more_info":"More info","select_bonus":"Change","skip_bonus":"Skip (no bonus)","reward":"Reward !","intro_header":"Let's start the\n sign up process","intro_description":"Preparing your awesome\n welcome bonuses"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/bonuses.json
// module id = 513
// module chunks = 245 986